// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1zY3r","head":"ProcedureTableInfo_head__3jzwo"};